import { render, staticRenderFns } from "./o-my-account-orders-history.vue?vue&type=template&id=159703ca&scoped=true&"
import script from "./o-my-account-orders-history.vue?vue&type=script&lang=js&"
export * from "./o-my-account-orders-history.vue?vue&type=script&lang=js&"
import style0 from "./o-my-account-orders-history.vue?vue&type=style&index=0&id=159703ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159703ca",
  null
  
)

export default component.exports